/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import { Card } from "@material-ui/core";
import { CheckCircleOutline, ErrorOutline } from "@material-ui/icons";
import { Dialog, Typography } from "@mui/material";

const Feedback = ({
  open,
  message,
  feedbackType,
  onClose,
}: {
  open: boolean;
  message: string;
  feedbackType: string;
  onClose?: any;
}) => {
  function noop() {}
  return (
    <Dialog open={open} onClose={onClose ?? noop}>
      {feedbackType == "success" ? (
        <Card style={{ backgroundColor: "#edf6ec" }}>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              padding: "2rem 4rem",
            }}
          >
            <CheckCircleOutline
              style={{
                fontSize: "8rem",
                lineHeight: 1,
                color: "#5cb85c",
              }}
            />
            <Typography
              style={{
                fontSize: "2.25rem",
                lineHeight: "2.5rem",
                fontWeight: 700,
                color: "#5cb85c",
                marginTop: "1.5rem",
              }}
            >
              Success
            </Typography>
            <Typography style={{ color: "gray", marginTop: "1rem" }}>
              {message}
            </Typography>
          </div>
        </Card>
      ) : (
        <Card style={{ backgroundColor: "#f6ebec" }}>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              padding: "2rem 4rem",
            }}
          >
            <ErrorOutline
              style={{ fontSize: "8rem", lineHeight: 1, color: "#F45050" }}
            />
            <Typography
              style={{
                fontSize: "2.25rem",
                lineHeight: "2.5rem",
                fontWeight: 700,
                color: "#F45050",
                marginTop: "1.5rem",
              }}
            >
              Error
            </Typography>
            <Typography style={{ color: "gray", marginTop: "1rem" }}>
              {message}
            </Typography>
          </div>
        </Card>
      )}
    </Dialog>
  );
};

export default Feedback;
